module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/50d1e5652da2e04f6d6f10fd32832356.png";